import styled from '@emotion/styled';
import { theme } from 'shared';

const { BREAKPOINTS, PADDING } = theme;
const { lessThanSmall, smallAndUp } = BREAKPOINTS;

export const FormContent = styled.div`
  @media (${smallAndUp}) {
    padding: 24px ${PADDING.content.smallAndUp.rightAndLeft} 0;
  }
  @media (${lessThanSmall}) {
    padding: 24px ${PADDING.content.lessThanSmall.rightAndLeft} 0;
  }
`;
